exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aljSgu2a4tOOxD_wf4pbP{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir=ltr] .aljSgu2a4tOOxD_wf4pbP{margin-left:10px}html[dir=rtl] .aljSgu2a4tOOxD_wf4pbP{margin-right:10px}html[dir=ltr] ._3CZ3JcgYYhlrTvrRyvgoYj{margin:0 5px 0 0}html[dir=rtl] ._3CZ3JcgYYhlrTvrRyvgoYj{margin:0 0 0 5px}", ""]);

// exports
exports.locals = {
	"statusDiv": "aljSgu2a4tOOxD_wf4pbP",
	"loadingStatus": "_3CZ3JcgYYhlrTvrRyvgoYj"
};